<template>
  <button
    :disabled="loading ?  loading : false"
    :class="loading ? 'disabled' : null"
    type="submit"
    class="w-full py-2 text-base text-center text-white rounded-lg cursor-pointer font-quietSans bg-primaryGreen"
  >
    <clip-loader color="white" size="15px" v-if="loading ?  loading : false"></clip-loader>
    <span v-else> {{ val }} </span>
  </button>
</template>

<script>
import ClipLoader from "vue-spinner/src/ClipLoader.vue";

export default {
  props: ["val", "loading"],
  components: {
    ClipLoader,
  },
  methods: {
    buttonClicked(){
      console.log("Button Clicked here")
    }
  }
};
</script>

<style></style>
